import { render } from "./CheckList.vue?vue&type=template&id=70d3c44a&scoped=true"
import script from "./CheckList.vue?vue&type=script&lang=js"
export * from "./CheckList.vue?vue&type=script&lang=js"

import "./CheckList.vue?vue&type=style&index=0&id=70d3c44a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sebastian\\Documents\\choferes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d3c44a"]])

export default __exports__